<template>
  <div class="info-wrapper editInfo-wrap">
    <h2>Display Setting</h2>
    <p>Enter and Update all your Display Setting here.</p>
    <div class="information-form mt-4">
      <ValidationObserver ref="observer" v-slot="{ handleSubmit }">
        <form
          @submit.prevent="handleSubmit(updateInfo)"
          ref="downlineRepDisplaySettingContainer"
        >
        <div class="form-group row">
            <span class="col-xxl-4 col-xl-5 col-lg-6 col-md-6 mb-3">
                <input-text
                  :rules="{ required: false, digits: 10 }"
                  labelFor="display_phone"
                  labelName="Display Phone "
                  :vmodel.sync="form.display_phone"
                  formGroupClass=""
                  inputType="text"
                 maxlength="10"
                 inputmode="numeric"
                 pattern="\d*"
                 @input.native="enforceDigitLimit"
                 @keypress.native="onlyAllowDigits"
                />
                <div class="mt-3 row justify-content-between validation-row">
                  <span class="validate-btn col-md-5 col-sm-6 d-flex rep-display-otp-validation"  v-if="showOtpSectionPhone">
                    <a href="#" class="validate-via-otp-link " @click.prevent="openOtpModal('phone')">
                      TO CONTINUE, PLEASE CLICK HERE TO VERIFY YOUR PHONE. 
                    </a>
                    
                    <!-- <span>Validating...</span>  -->
                  </span>
                </div>
            <div v-if="phoneMsg" class="message-container mt-2">
            <div :class="['validate-message', `${phoneValidationMessage.type}`]">
            <div :class="['message-indicator', `${phoneValidationMessage.type}-indicator`]"></div>
            <span class="message-text">
              <strong :class="`${phoneValidationMessage.type}-text`">{{ phoneValidationMessage.title }}</strong> - 
              {{ phoneValidationMessage.message }}
            </span>

              <button type="button" class="close-btn" onclick="this.parentElement.style.display='none';">
                 <span aria-hidden="true">&times;</span>
              </button>
          </div>
          </div>

            </span>
            <span class="col-xxl-4 col-xl-5 col-lg-6 col-md-6 mb-3">
                <input-text
                  :rules="{ required: false, email: true }"
                  labelFor="display_email"
                  labelName="Display Email "
                  :vmodel.sync="form.display_email"
                  formGroupClass=""
                />
                <div class="mt-3 row justify-content-between validation-row">
                  <!-- {/* Validate via OTP link */} -->
                  <span class="validate-btn col-md-5 col-sm-6 d-flex rep-display-otp-validation" v-if="showOtpSectionEmail">
                    <a href="#" class="validate-via-otp-link " @click.prevent="openOtpModal('email')">
                      TO CONTINUE, PLEASE CLICK HERE TO VERIFY YOUR EMAIL.
                    </a>
                    
                    <!-- <span>Validating...</span>  -->
                  </span>
                </div>
            <div v-if="emailMsg" class="message-container mt-2">
            <div :class="['validate-message', `${emailValidationMessage.type}`]">
            <div :class="['message-indicator', `${emailValidationMessage.type}-indicator`]"></div>
            <span class="message-text">
            <strong :class="`${emailValidationMessage.type}-text`">{{ emailValidationMessage.title }}</strong> - 
              {{ emailValidationMessage.message }}
            </span>

            <button type="button" class="close-btn" onclick="this.parentElement.style.display='none';">
            <span aria-hidden="true">&times;</span>
            </button>

          </div>
          </div>
            </span>  
        </div>
          <div class="form-group row">
            <input-text
              :rules="{ required: false }"
              labelFor="tagline"
              labelName="Tagline "
              :vmodel.sync="form.tagline"
              formGroupClass="col-xxl-4 col-xl-4 col-lg-4 col-md-6 mb-3"
            />
            <input-text
              :rules="{ required: false }"
              labelFor="group_appointment_url"
              labelName="Appointment Link"
              :vmodel.sync="form.appointment_url"
              formGroupClass="col-xxl-4 col-xl-4 col-lg-4 col-md-6 mb-3"
            />
            <div class="row">
              <div class="col-xxl-6 mt-3 my-profile-bio">
                <div class="profileInfo-block">
                  <h6>Bio</h6>
                  <div class="form-group mb-3">
                    <textarea
                      v-model="form.display_about_page"
                      placeholder="Enter your Bio here..."
                      rows="7"
                      class="profileInfo-field form-control"
                    ></textarea>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="form-group row" v-if="display_setting_image">
            <div class="col-xxl-6 col-xl-6 col-lg-6 col-md-12 mb-4">
              <figure>Where can I see this information?</figure>
              <img :src="display_setting_image" class="img-fluid" />
            </div>
          </div>

          <div class="row">
            <div class="col-xxl-3 col-xl-3 col-lg-3 col-md-6">
              <button type="submit" class="univ-btn">
                {{ isUpdate ? "Updating..." : "Update" }}
              </button>
            </div>
          </div>
        </form>
        <employer-email-verification
        v-if="showOtpModal"
        v-model="showOtpModal"
        :identifier="contactInfo"
        :identifierTypeText="otpType"
        @save="handleVerificationResult"
        @close="closeOtpModal"
        />
      </ValidationObserver>
    </div>
  </div>
</template>
<script>
import Api from "@/resource/Api";
import ApiSendOtp from "@/resource/BaseApi";

import EmployerEmailVerification from "@/views/DownlineRep/Nuera/DownlineOTPNuera.vue";

export default {
  name: "EmployerGroupDisplaySetting",
  props: {
    settings: {
      required: true,
    },
    tabIndex: {
      required: true,
    },
    appointmentUrl: {
      required: false,
    },
  },
  components: {
    EmployerEmailVerification,
  },
  data: () => ({
    form: {
      display_phone: "",
      display_email: "",
      tagline: "",
      group_id: "",
      display_about_page: "",
      appointment_url: "",
    },
    showOtpModal: false,
    isUpdate: false,
    display_setting_image: null,

   
     phoneMsg:false,
    phoneValidationMessage:null,
    emailMsg: false,
    emailValidationMessage:null,
    showOtpSectionEmail: false,
    showOtpSectionPhone: false,
     contactInfo: null,
        otpType: null,
        validationStatus: null,
        emailVerified: false,
        phoneVerified: false,
        skipEmailVerification: false,
        skipPhoneVerification: false,


    

  }),
  methods: {
        closeOtpModal() {
      this.showOtpModal = false;
    },
    
    enforceDigitLimit(event) {
    const raw = event.target.value;
    const digitsOnly = raw.replace(/\D/g, '').slice(0, 10);
    this.form.phone = digitsOnly;
    // Also fix the displayed value (if your component doesn't sync automatically)
    event.target.value = digitsOnly;
  },

   onlyAllowDigits(event) {
    const key = event.key;
    if (!/^\d$/.test(key)) {
      event.preventDefault();
    }
  },


  
    handleVerificationResult(result) {
    if (result.verified) {
      // Handle successful verification
      if (result.type === 'email') {
        this.emailMsg = true;
        this.emailVerified = true;
        this.emailValidationMessage = {
          type: 'success',
          title: 'Success',
          message: 'Your email has been verified!'
        };
        this.form['skip_validation_email'] = 1;
        this.showOtpSectionEmail = false;
      } else if (result.type === 'phone') {
        this.phoneMsg = true;
        this.phoneVerified = true;
        this.form['skip_validation_phone'] = 1;
        this.phoneValidationMessage = {
          type: 'success',
          title: 'Success',
          message: 'Your phone has been verified!'
        };
        this.showOtpSectionPhone = false;
      }
      this.$notify('Verification successful!');
    } 
    else if (result.skipped) {
      // Handle skipped verification
      if (result.type === 'email') {
        this.skipEmailVerification = true;
        this.form['skip_validation_email'] = 1;
        this.emailMsg = true;
        this.emailValidationMessage = {
          type: 'success',
          title: 'Success',
          message: 'Email verification was skipped'
        };
        this.showOtpSectionEmail = false;
      } else if (result.type === 'phone') {
        this.skipPhoneVerification = true;
        this.form['skip_validation_phone'] = 1;
        this.phoneMsg = true;
        this.phoneValidationMessage = {
          type: 'success',
          title: 'Success',
          message: 'Phone verification was skipped'
        };
        this.showOtpSectionPhone = false;
      }
      this.$notify('Verification skipped', 'warning');
    }
  },

  
       async openOtpModal(type) {
      if (type === "email" && !this.form.display_email) {
        this.$notify("Please enter an email address first.", "error");
        return;
      }

      if (type === "phone" && !this.form.display_phone) {
        this.$notify("Please enter a phone number first.", "error");
        return;
      }

      if(type==="email"){
        this.contactInfo=this.form.display_email;
        this.otpType = type;
     this.sendOtp();
      }

      else{
        this.contactInfo=this.form.display_phone;
        
        this.otpType = type;
     this.sendOtp();

      }
      this.showOtpModal = true;

      // this.contactInfo = type === "email" ? this.form.email : this.form.cell_phone;
      
    },


  async sendOtp() {
   try {
    const response = await ApiSendOtp.post('api/v2/send-common-otp', {
      contact: this.contactInfo,
      type: this.otpType,
          //  no_attempt_limit: 1,
      expiry_duration: 600,
    
    });
    if (response.data.success === true || response.data.status === 'success') {
  this.$notify('OTP sent successfully!');

  } 
  else {
  this.$notify(response.data.message || 'Failed to send OTP. Please try again.', 'error');
}
  } catch (error) {
    this.$notify('Failed to send OTP. Please try again.', 'error');
    console.error('OTP send error:', error);
  }
},



    updateInfo() {
        this.phoneMsg = false;
      this.emailMsg = false;
      this.phoneValidationMessage = null;
      this.emailValidationMessage = null;
      this.showOtpSectionEmail = false;
      this.showOtpSectionPhone = false;

      this.isUpdate = true;
      const url = `v3/update-display-settings`;
      let loader = this.$loading.show();
      console.log("Form Data", this.form);
      Api.put(url, this.form)
        .then((res) => {
          this.$notify(res.data.message);
           this.form.skip_validation_email = 0;
          this.form.skip_validation_phone = 0;
        })
        .catch((err) => {
        const errorMsg = err.response?.data?.message;

       if (errorMsg==="Phone number is invalid.") {
        this.phoneMsg = true;
        this.phoneValidationMessage = {
            type: "error",
            title: "Caution",
            message: "Invalid Phone Number, Please validate via OTP.",
          };
          this.showOtpSectionPhone = true;
          this.$notify("Phone is invalid. Please validate via OTP", "error");

          this.form.skip_validation_email = 1;
          this.form.skip_validation_phone = 0;


    }   
    else if (errorMsg==="Email is invalid."){

        this.emailMsg = true;
        this.emailValidationMessage = {
            type: "error",
            title: "Caution",
            message: "Invalid Email Address, Please validate via OTP.",
          };
          this.showOtpSectionEmail = true;
        this.$notify("Email is invalid. Please validate via OTP", "error");
          this.form.skip_validation_email = 0;
          this.form.skip_validation_phone = 1;

    

    } else if(errorMsg==="Email is invalid and Phone number is invalid."){

      
        this.phoneMsg = true;
         this.emailMsg = true;
        this.emailValidationMessage = {
            type: "error",
            title: "Caution",
            message: "Invalid Email Address, Please validate via OTP.",
          };
          this.showOtpSectionEmail = true;
          this.phoneValidationMessage = {
            type: "error",
            title: "Caution",
            message: "Invalid Phone Mumber, Please validate via OTP.",
          };
          this.showOtpSectionEmail = true;
          this.showOtpSectionPhone = true;
           this.$notify("Email and Phone are invalid.", "error");
           this.form.skip_validation_email = 0;
          this.form.skip_validation_phone = 0;

    } else if(errorMsg==="Email is already taken."){
        this.emailMsg = true;
        this.emailValidationMessage = {
            type: "error",
            title: "Caution",
            message: "The Email Address is already taken.",
          };
      this.$notify("The Email is already taken", "error");
                this.form.skip_validation_email = 0;
          this.form.skip_validation_phone = 1;
    }
    else if(errorMsg==="Phone number is already taken."){
        this.phoneMsg = true;
        this.phoneValidationMessage = {
            type: "error",
            title: "Caution",
            message: "The Phone Number is already taken.",
          };
      this.$notify("The Phone Number is already taken", "error");
                this.form.skip_validation_email = 1;
          this.form.skip_validation_phone = 0;
    }
    else if(errorMsg==="Email is already taken and Phone number is already taken."){
       this.phoneMsg = true;
        this.phoneValidationMessage = {
            type: "error",
            title: "Caution",
            message: "The Phone Number is already taken.",
          };
     this.emailMsg = true;
        this.emailValidationMessage = {
            type: "error",
            title: "Caution",
            message: "The Email Address is already taken.",
          };
      this.$notify("The Email and Phone Number are already taken", "error");
          this.form.skip_validation_email = 0;
          this.form.skip_validation_phone = 0;
    }

    else if(errorMsg==="Email is already taken and Phone number is invalid."){
    this.emailMsg = true;
        this.emailValidationMessage = {
            type: "error",
            title: "Caution",
            message: "The Email Address is already taken.",
          };
      this.phoneMsg = true;
        this.phoneValidationMessage = {
            type: "error",
            title: "Caution",
            message: "Invalid Phone Number, Please validate via OTP.",
          };
          this.showOtpSectionPhone = true;

      this.$notify("The Email is already taken and Phone is invalid", "error");
                this.form.skip_validation_email = 0;
          this.form.skip_validation_phone = 0;

     }
else if(errorMsg==="Email is invalid and Phone number is already taken."){
  this.emailMsg=true;
        this.emailValidationMessage = {
            type: "error",
            title: "Caution",
            message: "Invalid Email Address, Please validate via OTP.",
          };
          this.showOtpSectionEmail = true;
      this.phoneMsg = true;
        this.phoneValidationMessage = {
            type: "error",
            title: "Caution",
            message: "The Phone Number is already taken.",
          };
      this.$notify("The Phone Number is already taken and Email is invalid", "error");
                this.form.skip_validation_email = 0;
          this.form.skip_validation_phone = 0;
}
     else {
        this.$notify('Something went wrong please wait and try again', "error");
    }
        })
        .finally(() => {
          this.isUpdate = false;
          loader.hide();
          this.$refs.observer.reset();
        });
    },

  },
  watch: {
    settings: function (value) {
      if (value) {
        this.form = {
          display_phone: value.display_phone,
          display_email: value.display_email,
          tagline: value.tagline,
          group_id: value.group_id,
          display_about_page: value.display_about_page,
          appointment_url: this.appointmentUrl,
        };
        this.display_setting_image = value.display_setting_image ?? null;
      }
    },
    appointmentUrl: {
      immediate: true,
      deep: true,
      handler(value) {
        if (value) {
          this.form.appointment_url = value;
        }
      },
    },


     "form.display_email": {
    handler(newVal, oldVal) {
      if (newVal !== oldVal) {
        this.form['skip_validation_email'] = 0;
        this.emailMsg = false;
        this.emailValidationMessage = null;
        this.showOtpSectionEmail = false;
      
      }
    },
    immediate: true
  },
  "form.display_phone": {
    handler(newVal, oldVal) {

    const cleaned = newVal.replace(/\D/g, '').slice(0, 10);
    if (newVal !== cleaned) {
      this.form.phone = cleaned;
    }

      if (newVal !== oldVal)
        this.form['skip_validation_phone'] = 0;
        this.phoneMsg = false;
        this.phoneValidationMessage = null;
        this.showOtpSectionPhone = false;
        
      }
    },
    immediate: true
  
  },
  
};
</script>

<style>
.rep-display-otp-validation {
  border: 2px solid #e31717;
  padding: 5px;
  margin-left: 12px;
  font-size: 13px;
  font-weight: bold;
  width: 385px;
}

.rep-display-otp-validation:hover {
  border: 2px solid #a50e0e;
  box-shadow: #eb2a2a;
  background-color: aliceblue;
  cursor: pointer;
}
</style>
